<template>
    <section
        class="page-header"
        :style="{ backgroundImage: heroImg ? 'url(' + heroImg + ')' : '' }"
    >
        <div class="overlay"></div>
        <div
            class="header-content mx-auto max-w-2xl h-full flex justify-start items-end"
        >
            <div class="header-text">
                <h1 class="text-white uppercase font-bold">{{ title }}</h1>
                <p v-if="paragraph" class="text-white">{{ paragraph }}</p>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "PageHeader",
    props: {
        title: {
            type: String,
            required: true,
            default: "Page Title",
        },
        heroImg: {
            type: String,
            required: false,
            default: "",
        },
        paragraph: {
            type: String,
            required: false,
            default: "",
        },
    },
};
</script>

<style scoped lang="scss">
.page-header {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    height: 180px;

    @media (min-width: 640px) {
        height: 240px;
    }

    @media (min-width: 768px) {
        height: 300px;
    }

    @media (min-width: 1024px) {
        height: 360px;
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        background: linear-gradient(
            90deg,
            rgba(0, 0, 0, 0.6) 100%,
            rgba(0, 0, 0, 0.2) 100%
        );
        z-index: 1;

        @media (min-width: 768px) {
            background: linear-gradient(
                90deg,
                rgba(0, 0, 0, 1) 0%,
                rgba(0, 0, 0, 0) 100%
            );
        }
    }

    .header-content {
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        padding-right: 1rem;
        padding-bottom: 1.5rem;

        @media (min-width: 640px) {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            padding-bottom: 2rem;
        }

        @media (min-width: 768px) {
            padding-bottom: 3rem;
        }
    }

    .header-text {
        max-width: 100%;

        @media (min-width: 640px) {
            max-width: 30rem;
        }

        h1 {
            font-size: 1.5rem;
            line-height: 1.25;

            @media (min-width: 640px) {
                font-size: 1.5rem;
            }

            @media (min-width: 768px) {
                font-size: 2.25rem;
            }

            @media (min-width: 1024px) {
                font-size: 3rem;
            }
        }

        p {
            margin-top: 0.5rem;
            font-size: 0.875rem;

            @media (min-width: 640px) {
                font-size: 1rem;
            }
        }
    }
}
</style>
